import Nullstack from 'nullstack';
export default function IconBallBowling({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ball-bowling",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "9",
    x2: "11",
    y2: "9.01"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "8",
    x2: "15",
    y2: "8.01"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "12",
    x2: "14",
    y2: "12.01"
  }), " ");
}